import React from 'react'
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
function OrderStatus(props) {

    
    return (
        <div>

        <AppBar title={'About this application'}/><br/>
        <Box style={{padding:'5px'}}>
            <p>Order status</p>
        </Box>
        </div>
    )
}

export default OrderStatus